// @ts-nocheck

const resources: Record<string, Record<string, string>> = {
  'en-US': flattenObject(require('./en-US.json')),
  'es-US': flattenObject(require('./es-US.json')),
  'fr-CA': flattenObject(require('./fr-CA.json')),
  'ro-RO': flattenObject(require('./ro-RO.json')),
};

function flattenObject(obj, parentKey = '', result = {}) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = parentKey ? `${parentKey}:${key}` : key;
      if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        flattenObject(obj[key], newKey, result);
      } else {
        result[newKey] = obj[key];
      }
    }
  }
  return result;
}

export default resources;
